/**
 * @generated SignedSource<<09c71a4e371f868bd938f980d23486a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rowsContentRenderer_nativeIssueTable$data = {
  readonly " $fragmentSpreads": FragmentRefs<"timelineRowsContent_issueTableTimeline">;
  readonly " $fragmentType": "rowsContentRenderer_nativeIssueTable";
};
export type rowsContentRenderer_nativeIssueTable$key = {
  readonly " $data"?: rowsContentRenderer_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"rowsContentRenderer_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "rowsContentRenderer_nativeIssueTable",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "timelineRowsContent_issueTableTimeline"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "d29d55a907ecff5d44a158d59461a87f";

export default node;
